import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import Icon from '../icon';
import CircuitForm from './CircuitForm';
import EvChargerForm from './EvChargerForm';
import {useData} from '../../../../context/ConfigDataContext';

const MODES = {
  INITIAL: 'initial',
  ADD_CIRCUIT: 'circuit',
  ADD_EV_CHARGER: 'evCharger',
};

const AddNodeModal = () => {
  const {editNodeModalOpen, setEditNodeModalOpen, selectedNode} = useData();

  const InitialForm = () => {
    const content = selectedNode === '0' ? (
      <Button className="w-100 mb-3" onClick={() => setEditNodeModalOpen(MODES.ADD_CIRCUIT)}>Circuit</Button>
    ) : (
      <>
        <Button className="w-100 mb-3" onClick={() => setEditNodeModalOpen(MODES.ADD_CIRCUIT)}>Circuit</Button>
        <br/>
        <Button className="w-100 mb-5" onClick={() => setEditNodeModalOpen(MODES.ADD_EV_CHARGER)}>EV Charger</Button>
        <br/>
      </>
    );

    return (
      <>
        <Modal.Header>
          <Modal.Title>Add New Element</Modal.Title>
          <Icon name="puzzle" color={'#151515'} size={50}/>
        </Modal.Header>
        <Modal.Body>
          {content}
          <Button className="w-100 btn btn-secondary" onClick={() => setEditNodeModalOpen(false)}>Close</Button>
        </Modal.Body>
      </>
    );
  };

  const getVisual = () => {
    switch (editNodeModalOpen) {
      case MODES.ADD_CIRCUIT:
        return <CircuitForm/>;
      case MODES.ADD_EV_CHARGER:
        return <EvChargerForm/>;
      default:
        return <InitialForm/>;
    }
  };

  return (
    <Modal show={editNodeModalOpen} onHide={() => setEditNodeModalOpen(false)}>
      {getVisual()}
    </Modal>
  );
};

export default AddNodeModal;

